import moment from 'moment';

import { CommonDateFields } from '../graphql/athena/types/CommonDateFields';

/**
 * Format the given date like:
 *
 *   Tue, Apr 30
 *   <day>, <month> <date>
 *
 * Accepts a { withYear: boolean } option to add the year to the end of the string
 */
export const prettifyDate = (date: Date, withYear?: boolean): string => {
  // convert to a simple dateString, add comma after day name
  let newDate = date.toDateString().replace(/\s/, ', ');

  if (!withYear) {
    newDate = newDate.slice(0, -4);
  }

  return newDate.trim();
};

export const protoDateToDate = (date: CommonDateFields): Date => {
  const year = date.year;
  const month = date.month;
  const day = date.day;
  return new Date(year, month - 1, day);
};

export const dateToProtoDate = (date: Date): CommonDateFields => {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
};

// expects string date to be in format YYYY-MM-DD
export const stringDateToProto = (stringDate: string): CommonDateFields | null => {
  const parts = stringDate.split('-');
  if (parts.length < 3) {
    return null;
  }

  return {
    year: +parts[0],
    month: +parts[1],
    day: +parts[2],
  };
};

export const getWeekdayFromDate = (date: Date): string => {
  // returns number from 0 -> 6 representing Sunday -> Saturday
  const day = date.getDay();
  switch (day) {
    case 0:
      return 'Sunday';
    case 1:
      return 'Monday';
    case 2:
      return 'Tuesday';
    case 3:
      return 'Wednesday';
    case 4:
      return 'Thursday';
    case 5:
      return 'Friday';
    case 6:
      return 'Saturday';
    default:
      return '';
  }
};

export const isOlderThan48Hours = (date: Date | null) => {
  if (!date) {
    return true;
  }

  const dateDiff = moment().diff(moment(date), 'hours');
  return dateDiff > 48;
};
